import React, {useState,useContext,createContext,useEffect,useRef}  from 'react'
import {Form,Button,Container,Card,Alert,Table,Modal,Navbar,NavDropdown,Nav,Row,Col,Accordion} from 'react-bootstrap'
import FileUploadSports from './FileUploadSports';

import axios from 'axios'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBasketShopping,faEdit,faShop,faPlus,faBaseball } from '@fortawesome/free-solid-svg-icons'


export default function AdminUsers() {
    const [data,setData]=useState([])
    const [isLoading,setIsLoading]=useState(false)
    const [show, setShow] = useState(false);
    const [record,setRecord]=useState({})




    const columns = [
        {
            name: '#',
            selector: (row,index) =>  index+1,
            sortable: true,
            maxWidth:'5px'
        },
        {
            name: '',
            selector: row => <Button variant="secondary" onClick={()=>showModal(row.id)}><FontAwesomeIcon icon={faEdit}/></Button>,
            sortable: true,
            maxWidth:'5px'
        },

        {
            name: 'Όνομα',
            selector: row =>  row.UN,
            sortable: true
        },
  
        // {
        //     name: 'Default Γλώσσα',
        //     selector: row =>  row.LangName,
        //     sortable: true
        // },  
            
    ]
    

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(()=>{
        loadData()
    },[])




      const loadData=()=>{
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/adminusers',{
          headers: {
              'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
              }            
          })
        .then(res=>{
           console.log(res.data.results) 
          setData(res.data.results)
          setIsLoading(false)
          
        }).catch(err=>{
            setIsLoading(false)
            console.log(err)
        })          
      }



      const showModal=(id)=>{
        if (id==0){
            setRecord({ModalTitle:'ΝΕΑ ΕΓΓΡΑΦΗ', id:0,UN:'',Email:'',PWD:''})
            setShow(true)
        }else{
            const recObj=data.filter(item=>item.id==id)[0]
            console.log(recObj)
            setRecord({...recObj,ModalTitle:recObj.UN})
            setShow(true)            
        }

      }

      const save=(e)=>{
        e.preventDefault()
        //console.log(record)
        axios.post(process.env.REACT_APP_API_SERVER+'admin/adminusers',record,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }            
            })
          .then(res=>{
            if (res.data.err==0){
                loadData()
            }
            setShow(false)
            alert(res.data.msg)
        })
      }

      const deleteRecord=()=>{
        if (window.confirm('ΔΙΑΓΡΑΦΗ!!!! ΣΙΓΟΥΡΑ???')){
            axios.delete(process.env.REACT_APP_API_SERVER+'admin/sports/'+record.id,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                    }            
                })
              .then(res=>{
                if (res.data.err==0){
                    loadData()
                }
                setShow(false)
                alert(res.data.msg)
            })
        }
      }

    return (
        <>
            {isLoading &&
            <Alert variant='warning'>Loading....Please Wait</Alert>

            }

            {!isLoading &&
            <>
            <Alert variant="secondary">
                <table width="100%">
                    <tr>
                        <td><h5>Admin Users</h5></td>
                        <td align="right">
                        <Button  variant="dark" onClick={()=>showModal(0)}><FontAwesomeIcon icon={faPlus}/></Button>
                        </td>
                        <td width="10"></td>
                    </tr>
                </table>
                    
            </Alert>




                <DataTable
                columns={columns}
                data={data}
                highlightOnHover
                //expandableRows
                //expandableRowsComponent={ExpandedComponent}
                //pagination
                />            
            
            </>
            }

                <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                <Modal.Title>
                    {record.ModalTitle}
                </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                <Form onSubmit={save}>

                        <>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>User Name</Form.Label>
                            <Form.Control disabled={record.UN=='admin'} type="text" required value={record.UN} onChange={(e)=>setRecord({...record,UN:e.target.value})}/>
                        </Form.Group>
                        <br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" required value={record.Email} onChange={(e)=>setRecord({...record,Email:e.target.value})}/>
                        </Form.Group>
                        <br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Password</Form.Label>
                            <Form.Control minLength={6} maxLength={10} type="password" required value={record.PWD} onChange={(e)=>setRecord({...record,PWD:e.target.value})}/>
                        </Form.Group>
                        <br/>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Confirm Password</Form.Label>
                            <Form.Control minLength={6} maxLength={10} type="password" required value={record.PWD2} onChange={(e)=>setRecord({...record,PWD2:e.target.value})}/>
                        </Form.Group>
                        <br/>


                        <Row><Col></Col>
                        <Col md="auto">

                            {/* {record.id>0 &&
                            <>
                            <Button  variant="danger" style={{width:"150px"}} onClick={deleteRecord}>
                                Διαγραφή
                            </Button>
                            &nbsp; 
                            </>
                            } */}

                            <Button disabled={record.PWD!=record.PWD2} variant="success" type="submit" style={{width:"150px"}}>
                                Αποθήκευση
                            </Button>                      
                        </Col>
                      </Row>                        
                        </>
                   </Form> 


                             
                </Modal.Body>

            </Modal>   
        </>
    )
}
